module.exports = __webpack_public_path__ + "img/slide1.9aeb0c94.png";